import { FullTokenBalanceFragment } from '../../../../graphql/generated/graphql'

export const uniqueTokenBalances = (balances: FullTokenBalanceFragment[]) => {
    const seen: Record<string, boolean> = {}
    return balances.filter((balance) => {
        return seen.hasOwnProperty(balance.address) ? false : (seen[balance.address] = true)
    })
}
